/**
 * @generated SignedSource<<e3390a7604ebbe91cf1df9df235fca89>>
 * @relayHash 480478ec6c38a900703378266576bcc0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 56215da2315fa0a8d5c8b04954b631bd7a69afa620ceb41dcbb7a6bb91d754d7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useProductActivationCheckQuery$variables = {
  cloudIds: ReadonlyArray<string>;
};
export type useProductActivationCheckQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly confluence: {
      readonly active: string | null;
    } | null;
    readonly loom: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type useProductActivationCheckQuery = {
  response: useProductActivationCheckQuery$data;
  variables: useProductActivationCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "active"
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudIds",
        "variableName": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "alias": "confluence",
        "args": [
          {
            "kind": "Literal",
            "name": "product",
            "value": "confluence"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "activationIdByProduct(product:\"confluence\")"
      },
      {
        "alias": "loom",
        "args": [
          {
            "kind": "Literal",
            "name": "product",
            "value": "loom"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "activationIdByProduct(product:\"loom\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useProductActivationCheckQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useProductActivationCheckQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "480478ec6c38a900703378266576bcc0",
    "id": "56215da2315fa0a8d5c8b04954b631bd7a69afa620ceb41dcbb7a6bb91d754d7",
    "metadata": {},
    "name": "useProductActivationCheckQuery",
    "operationKind": "query",
    "text": "query useProductActivationCheckQuery(\n  $cloudIds: [ID!]!\n) {\n  tenantContexts(cloudIds: $cloudIds) {\n    confluence: activationIdByProduct(product: \"confluence\") {\n      active\n    }\n    loom: activationIdByProduct(product: \"loom\") {\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4a8a86302d657743a2e1c5d6d3888d7";

export default node;
